import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awsop-lab8',
  templateUrl: './awsop-lab8.component.html',
  styleUrls: ['./awsop-lab8.component.css']
})
export class AwsopLab8Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab8/awsop-lab8.component.ts